/**
 * The card-set ↔ bitmask primitive (JS half) — a set of cards as one 32-bit
 * integer, bit `ordinal` set iff the card is present (see docs/SERDE.md). A set
 * is one integer, not a list. The wire form is an unsigned decimal number; JS
 * bitwise ops coerce to signed 32-bit, so bit 31 (Clubs Ace) makes a raw mask
 * negative — `>>> 0` reads it back unsigned, the form that crosses the wire.
 */
import { ordinalOf, codeOf } from "./card-ordinal.js";

const CARD_COUNT = 32;

/** The unsigned 32-bit mask for a set of CardImage codes. */
export function maskOf(codes) {
  let mask = 0;
  for (const code of codes) {
    mask |= 1 << ordinalOf(code);
  }
  return mask >>> 0;
}

/** The CardImage codes present in a mask, ascending by ordinal. */
export function codesFromMask(mask) {
  const unsigned = mask >>> 0;
  const codes = [];
  for (let ordinal = 0; ordinal < CARD_COUNT; ordinal++) {
    if ((unsigned & (1 << ordinal)) !== 0) {
      codes.push(codeOf(ordinal));
    }
  }
  return codes;
}
